# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class FeaturedPublication extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'FeaturedPublicationModule'
#
#   @selector: ".featured_publication_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# FeaturedPublication.register()
